import styled from "styled-components";

export const LoginContainer = styled.div`
  display: flex;
  width: 100%;
  min-height: 100vh;
  background: #f8f9fa;
`;

export const RightPanel = styled.div`
  flex: 0 0 480px;
  background: #ffffff;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  padding: 60px 56px 80px;
  z-index: 1;
  box-shadow: -4px 0 24px rgba(0, 0, 0, 0.06);

  @media (max-width: 768px) {
    flex: 1;
    padding: 24px;
    box-shadow: none;
  }
`;

export const LoginContent = styled.div`
  width: 100%;
  max-width: 380px;
  .x-display {
    display: none;
  }
`;

export const ContainerLogo = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 40px;
`;

export const SeidorLogo = styled.img`
  height: 90px;
  opacity: 0.85;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 1;
  }
`;
